module.exports = __webpack_public_path__ + "roboto-italic-webfont-d88a9e8476fabedea3b87fd0ba2df3b3.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-italic-webfont.svg
// module id = 863
// module chunks = 88